var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ContentPageContainer',{key:_vm.refreshNotReadNumber,attrs:{"isIOSApp":_vm.isFromIOSAPP,"id":"InformationMessageDetail"}},[_c('SubHeader',{attrs:{"title":"お知らせ"}}),_c('MessageDetail',{key:_vm.refresh,attrs:{"message":_vm.stateMessage,"reply":_vm.reply,"imageSrc":_vm.imgSrc,"uploadFileError":_vm.uploadFileError}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }